import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { selector as commonSelector } from '@store/common';
import { toggleModal } from '@store/common/actions';
import { selector as filterContainerSelector } from '@store/filterContainer';
import {
  applyFilter,
  changeFilterContainerVisibility,
  createAndApplyFilter,
  createFilter,
  resetDrillDown,
  setInitialRule,
  updateAndApplyFilter,
  updateFilter,
  updateMeta,
} from '@store/filterContainer/actions';

import NewFilterPanel from './NewFilterPanel';

const selector = createSelector(
  filterContainerSelector,
  commonSelector,
  (filterContainer, common, router) => {
    const panel = filterContainer.newFilterPanel;
    return {
      categories: filterContainer.categories,
      category: panel.category,
      dimensions: filterContainer.dimensions,
      fid: panel.fid,
      name: panel.name,
      rule: panel.rule,
      isContent: panel.isContent,
      saving: panel.saving,
      subcategory: panel.subcategory,
      type: filterContainer.type,
      router,
      modal: common.modal,
      compareMode: common.compareMode,
      features: common.features,
    };
  },
);

export default connect(selector, {
  createAndApplyFilter,
  applyFilter,
  updateAndApplyFilter,
  updateFilter,
  updateMeta,
  toggleModal,
  resetDrillDown,
  createFilter,
  changeFilterContainerVisibility,
  setInitialRule,
})(NewFilterPanel);
